import { FileType } from '../../../../service/fileStore/IFileStoreService';
import { injectRootService } from '../../../../service/RootServiceFactory';
import { IMainLayoutDomainStore } from '../../../layout/main/store/domain/IMainLayoutDomainStore';
import { FileUploadUI } from './FileUploadUi';
import { IFileUploadDomain } from './IFileUploadDomain';
import { IFileUploadUI } from './IFileUploadUI';

export class FileUploadDomain implements IFileUploadDomain {
  constructor(
    public layoutDomain: IMainLayoutDomainStore,
    private rootService = injectRootService(layoutDomain.serviceType.value),
    public ui: IFileUploadUI = new FileUploadUI(),
  ) {}

  async uploadToFileStore(file, fileType: FileType) {
    return await this.rootService.fileStore.uploadImage(file, fileType);
  }

  async deleteFileFromStore(fileName: string, fileType: FileType) {
    return await this.rootService.fileStore.deleteByFile(fileName, fileType);
  }

  upLoad(files: any) {
    this.ui.files.setList(files);
  }
  loading(status, lenght) {}
  uppercaseFormater(list: string[]): string[] {
    const formattedList = list.map((item) => {
      return item.replace(/[\s.%]/g, '').toUpperCase();
    });
    return formattedList;
  }
}
